"use strict";

var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
var _createClass2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createClass.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _assertThisInitialized2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/assertThisInitialized.js"));
var _inherits2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/inherits.js"));
var _createSuper2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createSuper.js"));
var _defineProperty2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _EmergencyTab = _interopRequireDefault(require("./EmergencyTab.vue"));
var _TroubleServiceTab = _interopRequireDefault(require("./TroubleServiceTab.vue"));
var _RepairRequestTab = _interopRequireDefault(require("./RepairRequestTab.vue"));
var _FormEndTab = _interopRequireDefault(require("./FormEndTab.vue"));
var _FormContinueTab = _interopRequireDefault(require("./FormContinueTab.vue"));
var _TransferTab = _interopRequireDefault(require("./TransferTab.vue"));
var _formContract = require("@/types/formContract");
var CustomerFeedbackTab = /*#__PURE__*/function (_Vue) {
  (0, _inherits2.default)(CustomerFeedbackTab, _Vue);
  var _super = (0, _createSuper2.default)(CustomerFeedbackTab);
  function CustomerFeedbackTab() {
    var _this;
    (0, _classCallCheck2.default)(this, CustomerFeedbackTab);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "buildingId", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "StopContractType", _formContract.StopContractType);
    return _this;
  }
  return (0, _createClass2.default)(CustomerFeedbackTab);
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], CustomerFeedbackTab.prototype, "buildingId", void 0);
CustomerFeedbackTab = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    EmergencyTab: _EmergencyTab.default,
    TroubleServiceTab: _TroubleServiceTab.default,
    RepairRequestTab: _RepairRequestTab.default,
    FormEndTab: _FormEndTab.default,
    FormContinueTab: _FormContinueTab.default,
    TransferTab: _TransferTab.default
  }
})], CustomerFeedbackTab);
var _default = CustomerFeedbackTab;
exports.default = _default;